import { render, staticRenderFns } from "./ShowDescriptionPoUp.vue?vue&type=template&id=c5a4253a"
import script from "./ShowDescriptionPoUp.vue?vue&type=script&lang=js"
export * from "./ShowDescriptionPoUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports